import { Injectable, OnDestroy, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Build } from 'mbs-ui-shared@models/build';
import { SignalRService, WSTopicName } from 'mbs-ui-shared@modules';
import { CommonResponseType } from 'mbs-ui-shared@services/build-service/build-service.types';
import { BuildService } from 'mbs-ui-shared@services/build-service/build.service';
import { BuildsStore } from 'mbs-ui-shared@store/builds/builds.store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BuildsFacade implements OnDestroy {
  private store = inject(BuildsStore);
  private buildService = inject(BuildService);
  private signalR = inject(SignalRService);

  public builds = this.store.builds;
  public buildsInProgress = this.store.buildsInProgress;
  public settings = this.store.settings;
  public newVersionsAlerts = this.store.newVersionsAlerts;
  public connectFromBuilds = this.store.connectFromBuilds;

  public builds$ = toObservable(this.builds);
  public buildsInProgress$ = toObservable(this.buildsInProgress);
  public buildsSettings$ = toObservable(this.settings);
  public newVersionsAlerts$ = toObservable(this.newVersionsAlerts);
  public connectFromBuilds$ = toObservable(this.connectFromBuilds);

  constructor() {
    this.store.loadInitial();
    this.store.loadInProgress();
    this.initiateSignalR();
  }

  ngOnDestroy(): void {
    this.destroySignalR();
  }

  public updateBuildList(): void {
    this.store.requestRefresh();
  }

  public makePublic(build: Build): Observable<CommonResponseType> {
    return this.buildService.makePublic(build).pipe(tap(() => this.store.requestRefresh()));
  }

  public onTabVisit(tabId: string): void {
    this.store.markVersionsSeen(tabId);
  }

  private initiateSignalR(): void {
    this.signalR.authorizedZoneConnection.on(WSTopicName.OnBuildCompleted, () => {
      this.store.requestRefresh();
    });

    this.signalR.authorizedZoneConnection.on(WSTopicName.OnBuildStarted, (data: string) => {
      const parsed = JSON.parse(data);
      this.store.addInProgress(parsed.requestedBuilds);
    });
  }

  private destroySignalR(): void {
    this.signalR.authorizedZoneConnection.off(WSTopicName.OnBuildCompleted);
    this.signalR.authorizedZoneConnection.off(WSTopicName.OnBuildStarted);
  }
}
